import { LockKeyhole, Calculator, Eye } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../motion/Reveal";
import { GateDemo } from "../demo/GateDemo";
import { BRAND } from "../brand";

const POINTS: Array<{ Icon: LucideIcon; title: string; text: string }> = [
  {
    Icon: LockKeyhole,
    title: "Verrouillée sous votre seuil",
    text: "180 jours de retard par défaut, réglable dans les paramètres. En dessous, le bouton reste verrouillé.",
  },
  {
    Icon: Calculator,
    title: "Chiffrée pour vous",
    text: "Les factures choisies, les pénalités de retard et l’indemnité forfaitaire de 40\u00a0€ par facture, calculées à la date du courrier.",
  },
  {
    Icon: Eye,
    title: "Toujours relue par vous",
    text: `Rien ne part tout seul\u00a0: vous relisez l’aperçu du courrier. Son export en PDF et son envoi par email ou en recommandé depuis ${BRAND} sont en préparation.`,
  },
];

/** Le formel, quand il faut : la mise en demeure et son garde-fou. */
export function LateNotice() {
  return (
    <section
      id="mise-en-demeure"
      className="border-y border-border bg-surface py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-[1200px] gap-14 px-4 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:px-8">
        <div>
          <SectionHeading
            eyebrow="Le formel, quand il faut"
            title="La mise en demeure, préparée. Jamais envoyée à votre place."
            lead={`Quand l’amiable ne suffit plus, ${BRAND} rédige le courrier. Vous gardez la décision, et le moment.`}
          />
          <ul className="mt-10 space-y-6">
            {POINTS.map(({ Icon, title, text }, i) => (
              <Reveal as="li" key={title} delay={120 + i * 110} className="flex gap-4">
                <span className="grid size-10 shrink-0 place-items-center rounded-full bg-action-soft text-action">
                  <Icon aria-hidden className="size-[18px]" strokeWidth={1.75} />
                </span>
                <div>
                  <h3 className="text-base font-semibold text-foreground">{title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{text}</p>
                </div>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={480}>
            <p className="mt-10 border-l-2 border-border-strong pl-4 text-caption leading-relaxed text-subtle-foreground">
              Références&nbsp;: art. 1344 du Code civil (mise en demeure)&nbsp;; art. L441-10 et
              D441-5 du Code de commerce (pénalités de retard, indemnité forfaitaire).{" "}
              {BRAND} prépare le courrier, il ne remplace pas un conseil juridique.
            </p>
          </Reveal>
        </div>
        <Reveal delay={160}>
          <GateDemo />
        </Reveal>
      </div>
    </section>
  );
}
